import {
  createContext,
  type PropsWithChildren,
  useContext,
  useState,
} from "react"

import { getRepositoryName } from "../../app/routing"
import { trackLivePreviewModalOpen } from "../../app/services/tracking"
import { useDocument } from "../DocumentProvider"

type Dialog = undefined | "livePreview"

interface ContextValue {
  dialog: Dialog
  openDialog: (dialog: Dialog) => void
  closeDialog: () => void
}

const context = createContext<ContextValue>({
  dialog: undefined,
  openDialog: () => undefined,
  closeDialog: () => undefined,
})

export function SettingsMenuProvider(props: PropsWithChildren) {
  const { children } = props

  const [dialog, setDialog] = useState<Dialog>()
  const { documentId, customType } = useDocument()

  function openDialog(dialog: Dialog) {
    setDialog(dialog)

    if (dialog === "livePreview")
      trackLivePreviewModalOpen({
        customTypeId: customType.id,
        documentId: documentId ?? "",
        repositoryId: getRepositoryName(),
      })
  }

  function closeDialog() {
    setDialog(undefined)
  }

  const value: ContextValue = {
    dialog,
    openDialog,
    closeDialog,
  }

  return <context.Provider value={value}>{children}</context.Provider>
}

export function useSettingsMenu() {
  return useContext(context)
}
